<template>
  <main id="help-dashboard" class="site-main">
    <div class="grid-container">
      <div class="grid-x grid-padding-x">
        <div class="cell">
          <article>
            <h1>Setting up Vendor Portal Accounts</h1>

            <div class="grid-x grid-padding-x">
              <div class="cell large-auto small-order-2 large-order-1">
                <div class="panel">
                  <section class="help-section">
                    <h2 class="help-section__title">1. Have your vendors register for an account.
                    </h2>

                    <div class="help-section__details">
                      <p>Vendors can register for an account
                        <a
                          :href="'https://' + $store.state.shop.domain + '/apps/vendor-portal/login/?register=1'"
                          target="_blank">here</a>.
                      </p>

                      <p>Once registered they will not see any data as you will need to connect a
                        vendors data to this account.</p>
                    </div>

                    <div class="help-section__photo">
                      <img src="../../../assets/img/help/vendor-register.jpg"
                           alt="Register for a vendor account">
                    </div>
                  </section>

                  <section class="help-section">
                    <h2 class="help-section__title">2. Where to connect an account to a vendor.
                    </h2>

                    <div class="help-section__details">
                      <p>Once registered you will need to connect a vendor for the new login to see
                        any data. You can do this from the accounts page.</p>

                      <p>Once on the accounts page you will need to click "EDIT ACCOUNT" next to
                        the new account you want to assign a vendor to.</p>
                    </div>

                    <div class="help-section__photo">
                      <img src="../../../assets/img/help/accounts-page.jpg"
                           alt="Edit Accounts">
                    </div>
                  </section>

                  <section class="help-section">
                    <h2 class="help-section__title">3. Editing an account and assign vendors.
                    </h2>

                    <div class="help-section__details">
                      <p>In the edit account popup you will be able to search and assign multiple
                        vendors for an account to switch between in the portal. You can also disable
                        their account to prevent them from logging in if you need.</p>

                      <p>Once vendors are assigned, simply click save and that login account will now
                        be able to see the assigned vendor data.</p>

                      <p>If the vendor does not yet exist to assign, please proceed to make that
                        vendor. You can find a tutorial on setting them up
                        <router-link to="/help/setting-up-vendors">here</router-link>.</p>
                    </div>

                    <div class="help-section__photo">
                      <img src="../../../assets/img/help/edit-account.jpg"
                           alt="Add vendor">
                    </div>
                  </section>
                </div>
              </div>

              <div class="cell large-shrink small-order-1 large-order-2"
                   data-sticky-container>
                <div class="sidebar sticky" data-sticky data-margin-top="0"
                     style="min-width: 350px;"
                     v-sticky>
                  <div class="panel">
                    <div class="panel__header">
                      <h2>Table of Contents</h2>
                    </div>

                    <div class="panel__content">
                      <ol>
                        <li>Have your vendors register for an account.</li>
                        <li>Where to connect an account to a vendor.</li>
                        <li>Editing an account and assign vendors.</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
global.jQuery = require('jquery')
let $ = global.jQuery
window.$ = $

export default {
  name: 'connectingAccounts',
  components: {},
  created () {

  },
  directives: {
    sticky: function (el) {
      // eslint-disable-next-line
      new Foundation.Sticky($(el))
    },
    unbind: function (el) {
      $(el).foundation.destroy()
    }
  }
}
</script>

<style lang="scss">
@import '../../../styles/variables';
@import '../../../styles/mixins';

.help-section {
  margin-bottom: 45px;

  &__title {
    font-size: 18px;
  }

  &__details {
    margin-bottom: 15px;
    padding-left: 15px;
  }

  &__photo {
    margin-bottom: 15px;
    padding-left: 15px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &:last-child {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/help/articles/accounts-to-vendors.vue